import React from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { post_add_user_logs_status_api } from '../../api';

const AutoLogoutWrapper = ({ children, userStatus, handleLogout }) => {


        const pre_post_add_user_logs_status_api = async (user_status) => {
            const formData = new FormData();
  
            formData.append("user_status", user_status);
            try {
    
                  const response = await post_add_user_logs_status_api(
                    formData
                  );
            
                  if (
                    response &&
                    response?.data &&
                    response?.data?.response &&
                    response?.data?.response?.response === true &&
                    response?.data?.response?.data
                  ) {
                    
                  } else {
                    
                    console.error(
                      "Error",
                      response?.data?.error_msg || "Unknown error"
                    );
                    
                  }
                } catch (error) {
    
                  console.error("Error", error);
                }
        }

    const autoLogout = async () => {
        await pre_post_add_user_logs_status_api("offline");
        const userId = localStorage.getItem('AQATO_SuperAdminID');
    
        localStorage.removeItem('user_id');
    
        const channel = new BroadcastChannel('user-status-channel');
        channel.postMessage({ type: 'logout', userId });
        handleLogout();
        // window.location.href = '/';
      };

  const handleOnIdle = () => {
    // if (userStatus !== 'lunch' && userStatus !== 'oncall') {
      console.log('User idle for 1 hour. Logging out...');
      // autoLogout();
    // }
  };





  return (
    <IdleTimerProvider
      timeout={60 * 60 * 2500} // 2 hour
      onIdle={handleOnIdle}
      debounce={1000}
    >
      {children}
    </IdleTimerProvider>
  );
};

export default AutoLogoutWrapper;
